export const createTrainingSchema = {
  containersData: [
    {
      id: 'training-container-main',
      rowData: [
        {
          id: 'training-row-1',
          isDataRow: true,
          childData: [
            { id: 'fiscalYear',   type: 'Select', label: 'Fiscal Year',   isInfo: true, isMandatory: true },
            { id: 'quarter',      type: 'Select', label: 'Quarter',       isInfo: true, isMandatory: true },
            { id: 'grantId',      type: 'Select', label: 'Grant ID',      isInfo: true, isMandatory: true },
            { id: 'trainingType', type: 'Select', label: 'Training Type', isInfo: true, isMandatory: true },
          ],
        },
        {
          id: 'training-row-2',
          isDataRow: true,
          childData: [
            { id: 'priority', type: 'Select', label: 'Priority', isInfo: true, isMandatory: true },
            { id: 'tpc',      type: 'text',   label: 'TPC',      isInfo: true, isMandatory: true },
          ],
        },
        {
          id: 'training-row-section',
          isDataRow: true,
          childData: [
            { id: 'sectionTrack', type: 'SectionHeader', label: 'Training Track Lines', isInfo: false, isMandatory: false },
          ],
        },
        {
          id: 'training-row-3',
          isDataRow: true,
          childData: [
            { id: 'studentName', type: 'text',   label: 'Student Name', isInfo: true, isMandatory: true },
            { id: 'rank',        type: 'Select', label: 'Rank',         isInfo: true, isMandatory: true },
            { id: 'suffix',      type: 'text',   label: 'Suffix',       isInfo: true, isMandatory: false },
            { id: 'tmasl',       type: 'text',   label: 'T-MASL',       isInfo: true, isMandatory: false },
          ],
        },
        {
          id: 'training-row-4',
          isDataRow: true,
          childData: [
            { id: 'reportDate', type: 'DatePicker', label: 'Report Date', isInfo: true, isMandatory: true },
            { id: 'startDate',  type: 'DatePicker', label: 'Start Date',  isInfo: true, isMandatory: true },
            { id: 'endDate',    type: 'DatePicker', label: 'End Date',    isInfo: true, isMandatory: true },
            { id: 'location',   type: 'Select',     label: 'Location',    isInfo: true, isMandatory: true },
          ],
        },
        {
          id: 'training-row-5',
          isDataRow: true,
          childData: [
            { id: 'exa',              type: 'Select', label: 'EXA',               isInfo: true, isMandatory: true },
            { id: 'financialStatus',  type: 'Select', label: 'Financial Status',  isInfo: true, isMandatory: true },
            { id: 'facilityCategory', type: 'Select', label: 'Facility Category', isInfo: true, isMandatory: true },
          ],
        },
        {
          id: 'training-row-6',
          isDataRow: true,
          childData: [
            { id: 'description', type: 'Textarea',   label: 'Description', isInfo: true, isMandatory: false },
          ],
        },
        {
          id: 'training-row-7',
          isDataRow: true,
          childData: [
            { id: 'attachments', type: 'uploadfile', label: 'Attachments', isInfo: true, isMandatory: false },
          ],
        },
      ],
    },
  ],
  selectedLayout: {
    'training-row-1':       [3, 3, 3, 3],
    'training-row-2':       [3, 3],
    'training-row-section': [12],
    'training-row-3':       [3, 3, 3, 3],
    'training-row-4':       [3, 3, 3, 3],
    'training-row-5':       [3, 3, 3],
    'training-row-6':       [12],
    'training-row-7':       [12],
  },
}
